import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=5600fddd&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5600fddd')) {
      api.createRecord('5600fddd', component.options)
    } else {
      api.reload('5600fddd', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=5600fddd&", function () {
      api.rerender('5600fddd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2zZB8wWqMZq65/JS/offershelp.vue"
export default component.exports